// extracted by mini-css-extract-plugin
export var activityContainer = "_my-0";
export var typingIndicatorContainer = "_my-1";
export var typingIndicatorDot = "_my-2";
export var wave = "_my-3";